/**
 * Полосы шкалы риска доступа макета (prototype.js:314-318, risk): выше 60 — высокий (красный),
 * выше 25 — средний (жёлтый), остальное — низкий. Те же пороги у сервера: счётчик «с высоким
 * риском» (ResourceFacets.HIGH_RISK_ABOVE) и уровни сортировки каталога.
 */
import type { RiskSummary } from '@/api/workspaceTypes';

/** Высокий риск доступа — выше 60 из 100 */
export const RISK_HIGH_ABOVE = 60;
/** Средний риск доступа — выше 25 из 100 */
export const RISK_MEDIUM_ABOVE = 25;

/**
 * Коды факторов риска, у которых есть фраза проблемы (storages:riskProblem.<код>): вклады модели
 * хранилищ storage-access-v1 (ResourceRiskService) и факторы области «база» SQL
 * (AccessRecalculationService.scopeFactors). Совпадение с сервером проверяет riskLevels.test.ts
 */
export const RISK_PROBLEM_CODES = [
	'exposure',
	'write_access',
	'sensitive_share',
	'object_count',
	'sensitivity',
	'volume',
	'identities',
	'public_grant',
] as const;

const KNOWN_PROBLEMS: ReadonlySet<string> = new Set(RISK_PROBLEM_CODES);

/**
 * Главная проблема риска для баннера: фактор с наибольшим вкладом; без факторов или с кодом, для
 * которого фразы нет, — общая формулировка, а не сырой ключ
 */
export function riskProblemKey(risk: RiskSummary): string {
	const main = risk.factors.reduce<RiskSummary['factors'][number] | null>(
		(top, factor) => (top === null || factor.contribution > top.contribution ? factor : top),
		null,
	);
	return main && KNOWN_PROBLEMS.has(main.code)
		? `storages:riskProblem.${main.code}`
		: 'storages:riskProblem.default';
}
